import { Activity, TrendingUp, Calendar, Wallet, Home, FileText } from 'lucide-react';

const mockActivities = [
    { id: 1, action: 'Yeni daire satışı', detail: 'A Blok - 12', time: '2 saat önce', icon: Home, color: 'success' },
    { id: 2, action: 'Ödeme alındı', detail: '₺150.000', time: '5 saat önce', icon: Wallet, color: 'primary' },
    { id: 3, action: 'Taksit tahsilatı', detail: 'Ahmet Yılmaz - ₺25.000', time: 'Dün', icon: Calendar, color: 'warning' },
    { id: 4, action: 'Rapor oluşturuldu', detail: 'Aylık Gelir Raporu', time: '2 gün önce', icon: FileText, color: 'tertiary' },
    { id: 5, action: 'İnşaat güncellendi', detail: 'Yeşil Park Konutları', time: '3 gün önce', icon: TrendingUp, color: 'info' },
];

export default function ActivityLog() {
    const colorClasses = {
        success: 'bg-success/10 text-success',
        primary: 'bg-primary/10 text-primary',
        warning: 'bg-warning/10 text-warning',
        tertiary: 'bg-tertiary/10 text-tertiary',
        info: 'bg-info/10 text-info',
    };

    return (
        <div className="bg-bg-secondary rounded-2xl border border-border-light overflow-hidden">
            {/* Header */}
            <div className="px-6 py-4 border-b border-border-light bg-gradient-to-r from-bg-tertiary/50 to-transparent flex items-center justify-between">
                <div>
                    <h3 className="text-lg font-semibold text-text-primary flex items-center gap-2">
                        <Activity size={20} className="text-primary" />
                        Son Aktiviteler
                    </h3>
                    <p className="text-sm text-text-tertiary mt-0.5">Son 7 günlük işlemleriniz</p>
                </div>
                <button className="text-sm text-primary hover:text-primary-dark font-medium transition-colors">
                    Tümünü Gör
                </button>
            </div>

            {/* Activity List */}
            <div className="divide-y divide-border-light">
                {mockActivities.map((activity, index) => {
                    const Icon = activity.icon;
                    return (
                        <div
                            key={activity.id}
                            className="px-6 py-4 hover:bg-bg-tertiary/30 transition-colors flex items-center gap-4"
                        >
                            <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${colorClasses[activity.color]}`}>
                                <Icon size={20} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="font-medium text-text-primary">{activity.action}</p>
                                <p className="text-sm text-text-tertiary truncate">{activity.detail}</p>
                            </div>
                            <span className="text-xs text-text-muted whitespace-nowrap">{activity.time}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
